import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable camelcase */
import { useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { APOLLO_COMMERCE_CONTEXT, PaymentMethodType } from '@chegg/commerce-utils';
import { getCommerceErrors, fireErrorEvents, refetchQueries } from './useCreateRecurlyMop';
import { UPDATE_METHOD_OF_PAYMENT } from '../gql/updateMop';
import { transformRecurlyMopDetailsToPaymentMethodsData } from '../utils/TransformUtils';
import { updateMopList } from '../redux/MopOnFileState/MopOnFileState.actions';
import { updatePaymentMethodsData } from '../redux/MopOnFileState/MopOnFileState.helpers';
import { useAppSelector } from '../hooks/useAppSelector';
import { configSelector } from '../redux/ConfigState/ConfigState.selectors';
import { paymentMethodsSelector } from '../redux/MopOnFileState/MopOnFileState.selectors';
export var MOCK_UPDATE_MOP = {
  updateMethodOfPayment: {
    id: 'v5cq8tc3bqfr',
    isBackup: false,
    isPrimary: true,
    mopHolderName: 'ecom test',
    mopInfo: {
      card: {
        binCountry: 'ZZ',
        cardType: 'VISA',
        expMonth: 4,
        expYear: 2025,
        last4: '1111'
      },
      type: PaymentMethodType.CREDIT_CARD,
      venmo: {
        username: undefined
      }
    },
    updatedAt: '2024-06-27T17:02:53.000Z',
    user: {
      uuid: '78f6ae0e-ee5b-4e6b-9ffd-6cc31be9c13c'
    },
    billingAddress: {
      addressLine1: '3990 Freedom Cir',
      addressLine2: null,
      city: 'Santa Clara',
      state: 'CA',
      postalCode: '95054',
      country: 'US',
      phone: null
    },
    valid: true
  }
};

/**
 * Returns the response from Update Mop mutation
 */
var UseUpdateRecurlyMopHook = function UseUpdateRecurlyMopHook(props) {
  var dispatch = useDispatch();
  var config = useAppSelector(configSelector);
  var rioNamespace = config.rioNamespace;
  var paymentMethods = useAppSelector(paymentMethodsSelector);
  var mopId = props.mopId,
    isPrimary = props.isPrimary,
    isBackup = props.isBackup;
  var _useMutation = useMutation(UPDATE_METHOD_OF_PAYMENT, {
      variables: {
        updateMethodOfPaymentInput: {
          mopId: mopId,
          recurlyBillingInfoUpdateInput: {
            isBackup: isBackup,
            isPrimary: isPrimary
          }
        }
      },
      refetchQueries: refetchQueries,
      context: _defineProperty({}, APOLLO_COMMERCE_CONTEXT, true)
    }),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updateRecurlyMop = _useMutation2[0],
    _useMutation2$ = _useMutation2[1],
    updateMopData = _useMutation2$.data,
    updateMopError = _useMutation2$.error;
  var updateRecurlyMopForMopId = function updateRecurlyMopForMopId(_ref) {
    var mopId = _ref.mopId,
      isPrimary = _ref.isPrimary,
      isBackup = _ref.isBackup;
    return updateRecurlyMop({
      variables: {
        updateMethodOfPaymentInput: {
          mopId: mopId,
          recurlyBillingInfoUpdateInput: {
            isBackup: isBackup,
            isPrimary: isPrimary
          }
        }
      }
    });
  };
  useEffect(function () {
    if (updateMopData !== null && updateMopData !== void 0 && updateMopData.updateMethodOfPayment) {
      var updatedMop = transformRecurlyMopDetailsToPaymentMethodsData(updateMopData === null || updateMopData === void 0 ? void 0 : updateMopData.updateMethodOfPayment);
      dispatch(updateMopList({
        paymentMethods: updatePaymentMethodsData(paymentMethods, updatedMop)
      }));
    }
  }, [updateMopData]);
  useEffect(function () {
    if (updateMopError !== null && updateMopError !== void 0 && updateMopError.graphQLErrors) {
      var errors = getCommerceErrors(updateMopError.graphQLErrors);
      fireErrorEvents(errors, dispatch, rioNamespace);
    }
  }, [updateMopError]);
  return {
    updateRecurlyMop: updateRecurlyMop,
    updateRecurlyMopForMopId: updateRecurlyMopForMopId,
    updateMopData: updateMopData,
    updateMopError: updateMopError
  };
};
export default UseUpdateRecurlyMopHook;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/hooks/useUpdateRecurlyMop.js
// module id = 4644
// module chunks = 11